import { z } from 'zod'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

// 关键词也支持身份证号；连续长数字按敏感内容处理，避免进入 URL。
export function isSensitiveLicenseKeyword(value: string | undefined) {
  return value !== undefined && /\d{11,}/.test(value)
}

export const licenseListSearchSchema = z.object({
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z
    .string()
    .trim()
    .max(100)
    .refine((value) => !isSensitiveLicenseKeyword(value))
    .optional()
    .catch(undefined),
  ...creatorMemberSearchShape,
  ...createdAtSearchShape,
  ...createdAtSortSearchShape
})
